import React, { useEffect } from "react";
import "./Step2.scss";
import { isMobile } from "react-device-detect";
import { AiOutlineInfoCircle } from "react-icons/ai";
import SubmitButton from "../SubmitButton/SubmitButton";
import BackButton from "../BackButton/BackButton";
import "react-calendar/dist/Calendar.css";

import Calendar from "react-calendar";
// import dayjs from "dayjs";
import { BsCheck, BsChevronLeft, BsChevronRight } from "react-icons/bs";

const CalendarBack = () => (
  <div className="arrow arrow-back">
    <BsChevronLeft />
    <p>Tidigare</p>
  </div>
);

const CalendarNext = () => (
  <div className="arrow arrow-next">
    <p>Senare</p>
    <BsChevronRight />
  </div>
);

const Step2 = ({
  onSubmit,
  onBack,
  date,
  setDate,
  price,
  choosenService,
  leftKeyAtOffice,
  setLeyKeyAtOffice,
  isOffert,
}) => {
  useEffect(() => {
    if (isMobile && date) {
      const elem = document.getElementById("HowOften");
      if (elem) {
        elem?.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
    //eslint-disable-next-line
  }, [date]);

  return (
    <>
      <div className="Step2 white-shadow">
        <h1 className="heading">När ska vi putsa?</h1>
        <p className="description">
          Bokningsförfrågan är inte bindande utan ger oss möjlighet att titta i
          vårt schema för att se om datum finns ledigt. Vi återkopplar med
          bekräftelse så snart vi kan!
        </p>
        <div className="calendar-wrapper">
          <Calendar
            onChange={setDate}
            nextLabel={<CalendarNext />}
            prevLabel={<CalendarBack />}
            value={date}
            minDate={new Date()}
            // tileDisabled={({ date, view }) =>
            //   view === "month" && // Block day tiles only
            //   disabledDates.some(
            //     (disabledDate) =>
            //       date.getFullYear() === disabledDate.getFullYear() &&
            //       date.getMonth() === disabledDate.getMonth() &&
            //       date.getDate() === disabledDate.getDate()
            //   )
            // }
          />
        </div>
      </div>
      {!isOffert && (
        <div className="how-often white-shadow" id="HowOften">
          <h1 className="heading">Hur kommer vi in till bostaden?</h1>
          <div className="flex">
            <button
              className={"checkbox" + (!leftKeyAtOffice ? " active" : "")}
              onClick={(e) => setLeyKeyAtOffice(false)}
            >
              <BsCheck />
            </button>
            <div>
              <h3>Jag är hemma och öppnar</h3>
              <h6>Vi återkopplar med en exakt tid i bokningsbekräftelsen.</h6>
            </div>
          </div>
          <div className="flex">
            <button
              className={"checkbox" + (leftKeyAtOffice ? " active" : "")}
              onClick={(e) => setLeyKeyAtOffice(true)}
            >
              <BsCheck />
            </button>
            <div>
              <h3>
                Jag lämnar nyckel på Putsos kontor senast kl. 12 en arbetsdag
                innan
              </h3>
              <h6>Adress till närmaste kontor: </h6>
              <h5>Huskvarnavägen 62, 554 54 Jönköping</h5>
            </div>
          </div>

          {leftKeyAtOffice && (
            <div className="info">
              <AiOutlineInfoCircle />
              <p>
                Vi utför fönsterputsningen och lämnar därefter nyckeln i din
                brevlåda om inget annat anges.{" "}
              </p>
            </div>
          )}
        </div>
      )}
      <div className="buttons-flex">
        <BackButton text="Tillbaka" onClick={onBack} />
        <SubmitButton text="Fortsätt" isValid={date} onClick={onSubmit} />
      </div>
    </>
  );
};

export default Step2;
